import { render, staticRenderFns } from "./RukoGarantPlus.vue?vue&type=template&id=21b64e78&"
import script from "./RukoGarantPlus.vue?vue&type=script&lang=js&"
export * from "./RukoGarantPlus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports